import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile, backgroundImg) => ({
  welcomeMobile: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "column",
    color: "#ffffff",
    minHeight: "533px",
    borderRadius: "0px 0px 75px 75px",
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: "cover",
  },
  welcomeDesktop: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    pt: "100px",
    height: "944px",
    width: "100%",
    color: "#ffffff",
    minHeight: "533px",
    borderRadius: "0px 0px 70px 70px",
    background: `linear-gradient(to top, #252241, #211e3a, #1d1b32, #1a182b, #161424, #161424, #171525, #171525, #1b192d, #1f1d36, #23223f, #272648);`,
  },
  info: {
    zIndex: "modal",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexDirection: "column",
  },
  title: {
    width: isMobile ? "277px" : "630px",
    height: "fit-content",
    display: "flex",
    justifyContent: "center",
    alignItems: isMobile ? "center" : "flex-start",
    flexDirection: "column",
    lineHeight: "",
    textAlign: isMobile ? "center" : "left",
    marginBottom: "20px",
  },
  ApplyNowButton: {
    width: "192px",
    height: "52px",
    borderRadius: "100px",
    background: "linear-gradient(106deg, #f32c4d, #d00e2e);",
    color: theme.palette.white.main,
    textTransform: "none",
    fontSize: 15.5,
    fontWeight: 550,
    marginTop: isMobile ? "0px" : "30px",
  },
  icon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: "#d00e2e",
    bgcolor: theme.palette.white.main,
    ml: "3px",
  },
  intro: {
    backgroundColor: theme.palette.white.main,
    height: isMobile ? "fit-content" : "365px",
    margin: isMobile ? "100px 0px" : "-100px 0 0 0",
    width: isMobile ? "260px" : "80%",
    boxShadow: isMobile ? "none" : "0 4px 100px 0 rgba(199, 206, 211, 0.25)",
    borderRadius: isMobile ? "none" : "47px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  typography: {
    title: {
      fontFamily: isMobile
        ? theme.typography.montserrat.regular
        : theme.typography.montserrat.light,
      fontSize: isMobile ? 40 : 50,
      lineHeight: "1.15",
    },
    subtitle: {
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? 16 : { xl: 22, lg: 19 },
      marginTop: isMobile ? "0px" : "32px",
    },
    intro: {
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "23px" : { xs: "23px", md: "25px", xl: "30px" },
      color: theme.palette.blue.main,
      margin: isMobile ? "0" : { xs: "0", md: "40px 200px", xl: "50px 300px" },
    },
  },
});

const Welcome = () => {
  const isMobile = useMediaQuery("(max-width:1200px)");
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    title,
    subtitle,
    applyButtonTitle,
    description,
    backgroundImg,
    introIconImg,
  } = useTranslation(pathname, "Welcome");
  const classes = useStyles(theme, isMobile, backgroundImg);

  function goTo() {
    navigate("../aplica/intro");
  }

  return isMobile ? (
    <>
      <Box sx={classes.welcomeMobile}>
        <Box style={{ marginTop: "30px" }}>
          <Box sx={classes.title}>
            <Typography sx={classes.typography.title}>
              <b>{title.mobile[0]}</b>
            </Typography>
            <Typography sx={classes.typography.title}>
              {title.mobile[1]}
            </Typography>
          </Box>
          <Box sx={classes.title}>
            <Typography sx={classes.typography.subtitle}>
              {subtitle[0]}
              <b>{subtitle[1]}</b>
            </Typography>
          </Box>
        </Box>
        <Button
          sx={classes.ApplyNowButton}
          endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
          variant="contained"
          onClick={goTo}
        >
          {applyButtonTitle}
        </Button>
      </Box>
      <Box sx={classes.intro}>
        <Typography sx={classes.typography.intro}>
          <b>{description}</b>
        </Typography>
      </Box>
    </>
  ) : (
    <>
      <Box sx={classes.welcomeDesktop}>
        <Box sx={classes.info}>
          <Box sx={classes.title}>
            <Typography sx={classes.typography.title}>
              <b>{title.desktop[0]}</b>
            </Typography>
            <Typography sx={classes.typography.title}>
              <b>{title.desktop[1]}</b>
            </Typography>
            <Typography sx={classes.typography.title}>
              {title.desktop[2]}
            </Typography>
          </Box>
          <Typography sx={classes.typography.subtitle}>
            {subtitle[0]}
            <b>{subtitle[1]}</b>
          </Typography>
          <Button
            sx={classes.ApplyNowButton}
            endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
            onClick={goTo}
          >
            {applyButtonTitle}
          </Button>
        </Box>
        <img
          src={introIconImg}
          alt=""
          style={{ width: "400px", marginTop: "50px" }}
        />
      </Box>
      <Box sx={classes.intro}>
        <Typography sx={classes.typography.intro}>
          <b>{description}</b>
        </Typography>
      </Box>
    </>
  );
};

export default Welcome;
